import SearchIcon from "@mui/icons-material/Search";
import { Box, InputAdornment, TextField } from "@mui/material";
import type React from "react";
import { useRef, useState } from "react";

interface AnimatedSearchInputProps {
  searchText: string;
  onChange: (searchText: string) => void;
}

export const AnimatedSearchInput: React.FC<AnimatedSearchInputProps> = ({
  onChange,
  searchText,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: isExpanded ? "50%" : "55px",
          transition: "width 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
        }}
        onClick={() => {
          setIsExpanded(true);
          setTimeout(() => inputRef.current?.focus(), 100); // Focus the input on expand
        }}
        onBlur={() => {
          if (!searchText) setIsExpanded(false);
        }}
      >
        <TextField
          inputRef={inputRef}
          fullWidth
          variant="outlined"
          placeholder="Search..."
          value={searchText}
          autoFocus={isExpanded}
          focused={isExpanded}
          onChange={(e) => onChange(e.target.value)}
          InputProps={{
            sx: { borderRadius: 124, background: "transparent" },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "rgb(45, 41, 64)" }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
};
